import { createApiRef } from '@backstage/core-plugin-api';

export interface UsageBucketResponse {
  bucket: string;
  count: number;
}

export interface TopSkillResponse {
  skillName: string;
  invocationCount: number;
}

export interface DeadSkillResponse {
  skillName: string;
  lastInvokedAt: string;
}

export interface BySkillBucketResponse {
  key: string;
  invocationCount: number;
}

export type UsagePeriod = 'Day' | 'Week';
export type BySkillGroup = 'Repo' | 'User';

export interface DateRangeParams {
  From?: string;
  To?: string;
}

export interface UsageOverTimeParams extends DateRangeParams {
  Period?: UsagePeriod;
}

export interface TopSkillsParams extends DateRangeParams {
  Limit?: number;
}

export interface DeadSkillsParams {
  InactiveDays?: number;
}

export interface BySkillParams extends DateRangeParams {
  GroupBy?: BySkillGroup;
}

export interface TdpSkillsTelemetryApi {
  getUsageOverTime(params?: UsageOverTimeParams): Promise<UsageBucketResponse[]>;
  getTopSkills(params?: TopSkillsParams): Promise<TopSkillResponse[]>;
  getDeadSkills(params?: DeadSkillsParams): Promise<DeadSkillResponse[]>;
  getBySkill(skillName: string, params?: BySkillParams): Promise<BySkillBucketResponse[]>;
}

export const tdpSkillsTelemetryApiRef = createApiRef<TdpSkillsTelemetryApi>({
  id: 'plugin.tdp-skills-telemetry.api',
});
